import React, { useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import { FormControl, TextField } from '@material-ui/core';

type repoFieldType = {
  conditional: string;
  targetBranch: string;
  targetPath: string;
};

export const ExistingRepoOnly = ({
  onChange,
  rawErrors,
  formData,
}: FieldProps<string>) => {
  const [formState, setFormState] = useState<repoFieldType>({
    conditional: 'Add files to Existing Repo',
    targetBranch: '',
    targetPath: '',
  });

  const setFieldState = (key: string, value: string) => {
    const newState = {
      ...formState,
      [key]: value,
    };

    setFormState(newState);
    onChange(newState);
  };

  const renderTemplate = () => {
    return (
      <>
        <TextField
          id="targetPath"
          label="Target Path"
          variant="standard"
          error={rawErrors?.length > 0 && !formData}
          onChange={e => setFieldState('targetPath', e.target.value)}
          value={formState.targetPath || ''}
          helperText="Enter the name of the directory that you want to add the template files to (i.e. '.ci/')"
        />
        <TextField
          id="targetBranch"
          label="Target Branch"
          variant="standard"
          error={rawErrors?.length > 0 && !formData}
          onChange={e => setFieldState('targetBranch', e.target.value)}
          value={formState.targetBranch || ''}
          helperText="Enter the name of the branch that the PR should be opened against (i.e. 'develop')"
        />
      </>
    );
  };

  return <FormControl margin="normal">{renderTemplate()}</FormControl>;
};

export const existingRepoOnlyValidation = (
  value: repoFieldType,
  validation: FieldValidation,
) => {
  /** Regex allows any combination of letters, lowercase or uppercase, numbers and special chars !@#$%&()_=+}]|;'",<>- 
     Regex excludes special chars [^\?\\:.*\S  ( any whitespaces) based on valid branchnames for Azure */
  const branchRegex =
    /^([A-Za-z0-9!@#$%&()_=+}\]|;'",<>-]*$)(?!.*[[^\?\\:.*\S])/;

  /** Regex allows any combination of letters, lowercase or uppercase, numbers and special chars \
    Regex excludes any whitespaces */
  const targetPathRegex = /^([A-Za-z0-9\/]*$)(?!.*[[\S])/;

  if (JSON.stringify(value) !== '{}') {
    if (value.conditional === 'Add files to Existing Repo') {
      if (value.targetBranch.length <= 1) {
        validation.addError('Target Branch cannot be empty');
      }

      if (value.targetPath.length === 0) {
        validation.addError('Target path cannot be empty');
      } else if (!targetPathRegex.test(value.targetPath)) {
        validation.addError(
          'Target Path can not have whitespaces may only include upper and lowercase letters, numbers and the special char /',
        );
      }
    }
  } else {
    validation.addError('Please enter a target path and branch. ');
  }
};
